<template>
  <div class="top-level-page">
    <Chapterhead v-if="isChapter" :chapter="current"></Chapterhead>
    <content-page v-if="!isChapter" :page-slug="current.slug">
      <div class="content-page__html" v-html="pageContent"></div>
    </content-page>
  </div>
</template>

<script>
function isMenuPage(menuData, name) {
  const urls = [];
  if (menuData) {
    menuData.reduce((acc, val) => {
      urls.push(val.url);
      if (val.childItems) {
        const childUrls = val.childItems.map((obj) => obj.url);
        childUrls.forEach((url) => urls.push(url));
      }
    }, urls);
    if (!urls.find((url) => url.endsWith(`${name}/`))) {
      return true;
    }
  }
  return false;
}

import Chapterhead from "~/components/Chapterhead/Chapterhead";
import ContentPage from "~/components/ContentPage/ContentPage";
import GetChapterPage from "~/apollo/queries/getChapterPage";
import GetMediaItemById from "~/apollo/queries/getMediaItemById";
import { get } from "lodash";

export default {
  name: "DynamicLayoutSelector",
  components: {
    Chapterhead,
    ContentPage,
  },

  layout({ route, store }) {
    const slug = route.params.chap;
    const siteMenuData = store.state.menu.siteMenuData;
    const sidebarMenuData = store.state.menu.sidebarMenuData;
    if (isMenuPage(siteMenuData, slug) || isMenuPage(sidebarMenuData, slug)) {
      return "insidepage";
    } else {
      return "chapter";
    }
  },

  data() {
    return {
      layoutType: null,
    };
  },

  // fetch runs server side before the component is instantiated and populates the store
  // store values are then available when the component is rendered
  async fetch({ params, app, error, store }) {
    try {
      let response = await app.apolloProvider.defaultClient.query({
        query: GetChapterPage,
        fetchPolicy: "network-only",
        variables: {
          uri: params.chap,
        },
      });
      const chapter = response.data.pageBy;
      store.commit("chapter/setCurrentChapter", chapter);
      const { chapterImage } = chapter;
      if (chapterImage) {
        const chapterImageId = Number(chapterImage);
        if (chapterImageId) {
          response = await app.apolloProvider.defaultClient.query({
            query: GetMediaItemById,
            fetchPolicy: "network-only",
            variables: {
              id: chapterImageId,
            },
          });
          const url = response.data.mediaItemBy.sourceUrl;
          store.commit("chapter/setCurrentChapterImage", url);
        }
      }
    } catch (e) {
      error({ statusCode: 404, message: "Page not found" });
    }
  },

  head() {
    if (this.chapter) {
      return {
        title: `Living with White-tailed Deer: ${this.chapter.title}`,
      };
    }
    return {
      title: `Living with White-tailed Deer`,
    };
  },

  computed: {
    current() {
      return this.$store.state.chapter.current;
    },
    isChapter() {
      const siteMenuData = this.$store.state.menu.siteMenuData;
      const slug = get(this.$store.state.chapter.current, "slug");
      return !isMenuPage(siteMenuData, slug);
    },
    pageContent() {
      const host = this.$axios.defaults.baseURL;
      const { content } = this.$store.state.chapter.current;
      const fixedURLs = content.replace(
        /https:\/\/wtdi-wp\.wildlifeillinois\.org/g,
        host
      );
      return fixedURLs;
    },
  },

  created() {
    const siteMenuData = this.$store.state.menu.siteMenuData;
    if (isMenuPage(siteMenuData, this.chap)) {
      this.layoutType = "InsidePage";
    } else {
      this.layoutType = "Chapter";
    }
  },
};
</script>

<style scoped></style>
